import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Field} from 'redux-form'
import {FormField} from '@cred/react-form-field'
import Label from '@cred/react-label'
import defaultStyles from './themes/default/styles.module.scss'

const select = ({input, isDisabled = false, label, meta, children, placeholder, theme, icon = true}) => {
  const withValueCls = input.value ? defaultStyles.withValue : ''

  return (
    <FormField className={withValueCls} status={meta} error={meta.error} placeholder={placeholder} value={input.value} label={label} icon={icon} theme={theme}>
      <select disabled={isDisabled} {...input}>
        {children}
      </select>
      <Label>
        {label}
      </Label>
    </FormField>
  )
}

class Dropdown extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired
  }

  static defaultProps = {component: select}

  static displayName = 'Dropdown'

  render() {
    const {options, className, placeholder, ...props} = this.props,
      styles = this.props.styles || defaultStyles

    return (
      <div className={[styles.select, className].join(' ')}>
        <Field type="text" options={options} placeholder={placeholder} {...props}>
          <optgroup label="">
            {placeholder &&
              <option value="" disabled>
                {placeholder}
              </option>
            }
            {options.map((option, index) =>
              <option key={index} value={option.value}>
                {option.label}
              </option>
            )}
          </optgroup>
        </Field>
      </div>
    )
  }
}

export {Dropdown}

export default Dropdown
